<input (change)="updateModel($event)" [value]="value" type="checkbox" [name]="name" id="{{name}}" [required]="required" [checked]="model == value">
<label class="radio" [attr.for]="name">{{label}}</label>
<input type="text" *ngIf="hasTextinput" #inputValue [class.disabled]="model != value" [disabled]="model != value" (change)="changeTextInput(inputValue.value)">
